/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single time bucket for time series metrics
 */
export type TimeSeriesBucket = {
  /**
   * Abandoned chat sessions in this bucket
   */
  abandonedChats: number;
  /**
   * Average session duration in milliseconds
   */
  avgSessionDurationMs: number;
  /**
   * Average tool latency in milliseconds
   */
  avgToolLatencyMs: number;
  /**
   * Bucket start time in Unix nanoseconds (string for JS precision)
   */
  bucketTimeUnixNano: string;
  /**
   * Sum of cache creation input tokens in this bucket
   */
  cacheCreationInputTokens: number;
  /**
   * Sum of cache read input tokens in this bucket
   */
  cacheReadInputTokens: number;
  /**
   * Failed chat sessions in this bucket
   */
  failedChats: number;
  /**
   * Failed tool calls in this bucket
   */
  failedToolCalls: number;
  /**
   * Partially resolved chat sessions in this bucket
   */
  partialChats: number;
  /**
   * Resolved chat sessions in this bucket
   */
  resolvedChats: number;
  /**
   * Total chat sessions in this bucket
   */
  totalChats: number;
  /**
   * Total cost in this bucket
   */
  totalCost: number;
  /**
   * Sum of input tokens in this bucket
   */
  totalInputTokens: number;
  /**
   * Sum of output tokens in this bucket
   */
  totalOutputTokens: number;
  /**
   * Sum of all tokens in this bucket
   */
  totalTokens: number;
  /**
   * Total tool calls in this bucket
   */
  totalToolCalls: number;
};

/** @internal */
export const TimeSeriesBucket$inboundSchema: z.ZodMiniType<
  TimeSeriesBucket,
  unknown
> = z.pipe(
  z.object({
    abandoned_chats: z.int(),
    avg_session_duration_ms: z.number(),
    avg_tool_latency_ms: z.number(),
    bucket_time_unix_nano: z.string(),
    cache_creation_input_tokens: z.int(),
    cache_read_input_tokens: z.int(),
    failed_chats: z.int(),
    failed_tool_calls: z.int(),
    partial_chats: z.int(),
    resolved_chats: z.int(),
    total_chats: z.int(),
    total_cost: z.number(),
    total_input_tokens: z.int(),
    total_output_tokens: z.int(),
    total_tokens: z.int(),
    total_tool_calls: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "abandoned_chats": "abandonedChats",
      "avg_session_duration_ms": "avgSessionDurationMs",
      "avg_tool_latency_ms": "avgToolLatencyMs",
      "bucket_time_unix_nano": "bucketTimeUnixNano",
      "cache_creation_input_tokens": "cacheCreationInputTokens",
      "cache_read_input_tokens": "cacheReadInputTokens",
      "failed_chats": "failedChats",
      "failed_tool_calls": "failedToolCalls",
      "partial_chats": "partialChats",
      "resolved_chats": "resolvedChats",
      "total_chats": "totalChats",
      "total_cost": "totalCost",
      "total_input_tokens": "totalInputTokens",
      "total_output_tokens": "totalOutputTokens",
      "total_tokens": "totalTokens",
      "total_tool_calls": "totalToolCalls",
    });
  }),
);

export function timeSeriesBucketFromJSON(
  jsonString: string,
): SafeParseResult<TimeSeriesBucket, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TimeSeriesBucket$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TimeSeriesBucket' from JSON`,
  );
}
